import { render, staticRenderFns } from "./SectionLook.vue?vue&type=template&id=d52f8972&scoped=true&"
import script from "./SectionLook.vue?vue&type=script&lang=js&"
export * from "./SectionLook.vue?vue&type=script&lang=js&"
import style0 from "./SectionLook.vue?vue&type=style&index=0&id=d52f8972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52f8972",
  null
  
)

export default component.exports